import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import { AxiosError } from 'axios';

import { RootModel } from '../models';
import { createSceneGroup } from '../../services/tour.service';
import { showMessage } from '../../utils/messageError';

export const storeName = 'sceneGroup';

const initialState = {
  data: [],
  loading: false,
};

export const sceneGroup: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setSceneGroups: produce((state, payload) => {
      state.data = payload;
    }),
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof sceneGroup>) => ({
    async saveSceneGroup(payload, state) {
      this.setLoading(true);
      const { id: tourId, code: tourCode, lastModifiedDate } = state.tourDetail.data;
      const request = { sceneGroups: payload };

      try {
        await createSceneGroup(tourId, { ...request, lastModifiedDate });
        message.success('Success to update sceneGroup');
        dispatch.tourDetail.getTour(tourCode);
      } catch (err: unknown) {
        const axiosError = err as AxiosError;
        console.error(axiosError.message);
        showMessage(axiosError, `Fail to update sceneGroup: ${axiosError.message}`);
      } finally {
        this.setLoading(false);
      }
    },
  }),
});

export default sceneGroup;
